<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  mounted() {
    this.renderChart(
      {
        labels: [
          "Q_01",
          "Q_02",
          "Q_03",
          "Q_04",
          "Q_05",
          "Q_06",
          "Q_07",
          "Q_08",
          "Q_09",
          "Q_10"
        ],
        datasets: [
          {
            label: "Prova 01",
            backgroundColor: "rgba(0,220,0,.2)",
            data: [82, 40, 58, 79, 77, 84, 51, 45, 71, 80]
          },
          {
            label: "Prova 02",
            backgroundColor: "rgba(220,0,0,.2)",
            data: [75, 62, 45, 69, 70, 86, 77, 51, 63, 40]
          },
          {
            label: "Prova 04",
            backgroundColor: "rgba(0,0,220,.2)",
            data: [77, 43, 64, 48, 75, 70, 67, 72, 82, 60]
          },
          {
            label: "Prova 04",
            backgroundColor: "rgba(0,0,0,.2)",
            data: [83, 77, 50, 55, 51, 69, 60, 80, 66, 63]
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>

<style>
</style>